import {Helmet} from "react-helmet";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import titleImage from "../../assets/images/titleImage.png";
import s from "./News.module.scss";
import {Aside} from "../../components/Aside/Aside";
import LoadingInside from "../../components/Loading/LoadingInside";

const News = () => {
  const breadcrumbItems = [
    {name: 'ホーム ', link: '/'},
    {name: 'キャンペーン'}
  ];
  const API_URL = process.env.REACT_APP_API_LOCAL_URL;

  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const res = await axios.get(`${API_URL}news-all`);
      setNews(res.data.data || res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  if (loading) return  <LoadingInside height={"90vh"}/>;
  return (
      <div className={"  vh-60"}>
        <Helmet>
          <title>キャンペーン – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】</title>
          <meta property="og:title"
                content="キャンペーン – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】"/>
          <meta property="og:url" content={`${process.env.REACT_APP_API_URL}/news`}/>
          <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！"/>
          <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！"/>
          <meta property="og:type" content="article"/>
        </Helmet>
        <div className={"row mt-3"}>
          <div className={"col-12"}>
            <Breadcrumb items={breadcrumbItems}/>
            <div className={s.titleContainer}>
              <h2><img className={s.titleImage} src={titleImage}/>News</h2>
            </div>
          </div>
        </div>
        <div className={"row mt-3"}>
          <div className={"col-12  col-md-8"}>
            <div className={"row"}>
              {news.map((blog) => (
                  <div key={blog.id} className={"col-12 col-md-4"}>

                    <a key={blog.id} href={`/news/${blog.slug}`}  rel="noopener noreferrer">
                      <div className="card" >


                        {blog.banner ? (
                            <img
                                src={blog.banner}
                                alt={blog.name}
                                className={s.extraCard__image}
                            />
                        ) : (
                            <div className={s.extraCard__placeholder}>
                              No Image
                            </div>
                        )}
                        <div className="card-body">
                          <h5 className="card-title">{blog.newsTitle}</h5>
                          <p className="card-text">{blog.date}</p>
                        </div>
                      </div>

                    </a>
                  </div>
              ))}
            </div>
          </div>
          <div className={"col-12 col-md-4"}>
            <Aside/>
          </div>
        </div>

      </div>
  );
}

export default News;
